module.exports = __webpack_public_path__ + "img/link.6745fb23.svg";